import { Component,OnInit } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { IntegrationService } from '../integration.service';
import { Router } from '@angular/router';
import { NotifierService } from "angular-notifier";
declare var Chargebee;
import axios from 'axios'

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})

export class CheckoutComponent implements OnInit {
  // To store card component instance, (from ready event)
  cbInstance;
  private userId;
  private readonly notifier: NotifierService;
  public username;
  public phone;
  public email;
  loading;
  iframeUrl;
  constructor(private _integrationService:IntegrationService,public http:HttpClient,private router:Router,notifierService: NotifierService){
    this._integrationService.userId$.subscribe((data)=>{this.userId=data});
    this._integrationService.userName$.subscribe((data)=>{this.username=`${data[0].toUpperCase()}${data.slice(1,)}`.replace('My','')});
    this._integrationService.phone$.subscribe((data)=>{this.phone=data})
    this._integrationService.email$.subscribe((data)=>this.email=data)
    this.notifier = notifierService;
    this.iframeUrl = ''
    this.cbInstance = Chargebee.init({
      site: "subscrybe"
    })
  }
  // handleCheckout(event){
  //   let reqData = {
  //     planId:'subscrybe-premium',
  //     subscriberId:this.userId.replace(/"/g,""),
  //     email:this.email,
  //     name:this.username,
  //     phone:this.phone
  //   }
  //   this.loading = true;
  //   let endpoint = 'https://subscrybe-backend.herokuapp.com/subscriptions/generate_checkout_new_url'
  //   this.http.post(endpoint,reqData).subscribe(data=>{
  //     this.iframeUrl = data['url']
  //     this._integrationService.checkoutUrlSubject.next(this.iframeUrl)
  //     console.log(this.iframeUrl)
  //     this._integrationService.listViewPromoSubject.next(1)
  //   })
  // }


  handleCheckout(event){
    let reqData = {
      planId:'subscrybe-premium',
      subscriberId:this.userId.replace(/"/g,""),
      email:this.email,
      name:this.username,
      phone:this.phone
    }

    console.log(reqData)
    this.loading = true;
    let endpoint = 'https://subscrybe-backend.herokuapp.com/subscriptions/generate_checkout_new_url'
    // this.http.post(endpoint,reqData).subscribe(data=>{
    //   window.open(data['url'])
    // })
    this.cbInstance.openCheckout({
      hostedPage:() =>{
        var data = reqData;
        return axios.post(endpoint,reqData).then((response) => response.data)
      },
      success(hostedPageId){
        console.log(hostedPageId);
      },
      close:() =>{
        this.loading = false;
        this.notifier.notify("success", "Congratulations! You are now a premium subscribe user");
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard']);
        }); 
      },
      step(step){
        if(step == 'thankyou_screen'){
          // this._integrationService.getUser();
          localStorage.setItem('upgradedNotif','true')
        }
      }
    })
    event.preventDefault();
  }


  ngOnInit(){
    this._integrationService.getUser();
  }




}